import './PrimaryButton.css';
import Spinner from '../Spinner/Spinner';
import React from 'react';

interface PrimaryButtonProps {
  children: React.ReactNode;
  'aria-label'?: string;
  loading?: boolean;
  disabled?: boolean;
  onClick: (e: React.MouseEvent) => void;
}

function PrimaryButton({
  disabled = false,
  onClick,
  loading = false,
  children,
  ...btnProps
}: PrimaryButtonProps): React.ReactNode {
  function handleMouseMove(e: React.MouseEvent<HTMLButtonElement>) {
    const el = e.currentTarget.getBoundingClientRect();
    const position = ((e.clientX - el.left) / el.width) * 100;
    e.currentTarget.style.setProperty('--button-light-position', `${position}%`);
  }

  return (
    <button
      className={`primary-button ${loading ? 'loading' : ''}`}
      onMouseMove={handleMouseMove}
      onClick={onClick}
      disabled={disabled || loading}
      aria-busy={loading}
      {...btnProps}
    >
      {loading ?
        <Spinner />
      : <></>}
      {children}
    </button>
  );
}

export default PrimaryButton;
